var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBase = function SvgBase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 100 100"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#base_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#0052FF",
    rx: 50
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052FF",
    d: "M50 100c27.614 0 50-22.386 50-50S77.614 0 50 0 0 22.386 0 50s22.386 50 50 50"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M50.221 84.746c19.38 0 35.09-15.683 35.09-35.028 0-19.346-15.71-35.028-35.09-35.028-18.386 0-33.47 14.115-34.967 32.083h46.38v5.89h-46.38C16.752 70.63 31.835 84.745 50.22 84.745"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "base_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#fff",
    rx: 50
  })))));
};
export default SvgBase;